// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"42a82b6b","239":"dc05ce36","447":"802f5880","535":"bd84f2b2","572":"cd596b38","977":"fbac28d8","995":"3bfcc3b0"}[chunkId] + ".chunk.js";
};